<template>
  <div>
    <d-table ref="table" :data="mentees" :show-detail-icon="false" :loading="loadingMentees" paginated backend-pagination detailed :total="total" backend-search backend-sorting :default-sort="[pagination.sortField, pagination.sortOrder]" striped detail-key="id" default-sort-direction="desc" show-search :per-page="pagination.pageSize" :search.sync="filter" @page-change="page => pagination.page = page" @sort="onSort">
      <template #action-buttons>
        <h2 class="text-primary-500 mb-0">
          Mentees
        </h2>
      </template>

      <template #action-buttons-right>
        <div class="flex space-x-4">
          <d-btn class="" @click="launchAddMenteeModal()">
            + Add Mentee
          </d-btn>
        </div>
      </template>

      <template slot-scope="props">
        <d-table-column field="firstName" :row="props.row" label="Name" sortable>
          {{ props.row.firstName }} {{ props.row.lastName }}
        </d-table-column>
        <d-table-column field="preferredEmail" :row="props.row" label="Email" />
        <d-table-column label="Profile">
          <a class="text-secondary-500 underline" :href="'/users/profile/' + props.row.id">View Profile</a>
        </d-table-column>
        <d-table-column class="text-right">
            <d-icon icon="envelope" class="cursor-pointer ml-4" @click.native="launchNotificationsModal(props.row)" />
            <d-icon icon="trash" class="cursor-pointer text-red-500 ml-4" @click.native="removeMentee(props.row)" />
        </d-table-column>
      </template>
    </d-table>
  </div>
</template>

<script>
  import axios from 'axios';
  import AddMenteeModal from './AddMenteeModal.vue';
    import ViewNotificationModal from '@resources/scripts/patterns/ViewNotificationModal.vue';

  export default {
    parent: true,

    props: {
      mentor: {
        type: Object,
        default: () => {},
      },
    },
    data: () => ({
      mentees: [],
      loadingMentees: false,
      total: 0,
      filter: '',
      pagination: {
        page: 1,
        pageSize: 50,
        sortField: 'firstName',
        sortOrder: 'asc',
      },
    }),

    watch: {
      pagination: {
        handler() {
          this.getMenteesPaged();
        },
        deep: true,
      },
      filter() {
        this.getMenteesPaged();
      },
    },

    mounted() {
      this.getMenteesPaged();
    },

    methods: {
        launchNotificationsModal(user) {
            this.$modal.open({
                parent: this,
                component: ViewNotificationModal,
                hasModalCard: true,
                props: {
                    entityId: user.id,
                    type: 'user',
                    name: user.fullName,
                },
            });
        },
      async getMenteesPaged() {
        const {
          page, sortField, sortOrder, pageSize,
        } = this.pagination;
        const params = [`filter=${this.filter}`, `sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`].join('&');
        this.loadingMentors = true;
        const { data } = await axios.get(`/api/admin/users/mentor/${this.mentor.id}/mentees/paged?${params}`);
        this.mentees = data.resultItems;
        this.loadingMentors = false;
      },

      launchAddMenteeModal() {
        this.$modal.open({
          parent: this,
          component: AddMenteeModal,
          hasModalCard: true,
          width: 500,
          events: {
            getMenteesPaged: () => this.getMenteesPaged(),
          },
          props: {
            selectedMentorId: this.mentor.id,
          },
        });
      },

      async removeMentee(user) {
        this.$dialog.confirm({
          title: 'Removing Mentee',
          message: `Are you sure you want to <b>remove</b> ${user.firstName} ${user.lastName} as a mentee? This action cannot be undone.`,
          confirmText: 'Remove',
          confirmColor: 'red-500',
          onConfirm: async () => {
            await axios.delete(`/api/admin/users/mentor-mentee?mentorId=${this.mentor.id}&menteeId=${user.id}`);
            this.getMenteesPaged();
            this.$toast.open('Mentee removed!');
          },
        });
      },

      onSort(field, order) {
        this.pagination.sortField = field;
        this.pagination.sortOrder = order;
      },

    },
  };
</script>
